import * as React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import useBoardIdByKey from "../../../hooks/useBoardIdByKey";
import { searchCard } from "../../../redux/SearchSlice";
import { setSideBarDrawer } from "../../../redux/Sidebar";
import { filterUser } from "../../../redux/usersSlice";
import { currentUserId } from "../../../utils/constants";

export function useSidebarBoardItem(board) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useBoardIdByKey();
  const userId = currentUserId();

  const handleClick = React.useCallback(() => {
    if (id !== board.board_id) {
      dispatch(searchCard(""));
      dispatch(filterUser(null));
      dispatch(setSideBarDrawer(false));
    }
  }, [board.board_id, dispatch, id]);

  const handleAssignedCardsClick = React.useCallback(
    (event) => {
      event.preventDefault();
      navigate(`/board/${board.key}?search=${userId}`);
    },
    [board.key, navigate, userId]
  );

  return {
    handleClick,
    handleAssignedCardsClick,
  };
}
